<template>
  <ion-page>
    <master-layout pageTitle="لیست خودروهای مشتریان">
      <ion-card>
        <ion-card-content>
          <DataTable auto-reload="1" v-if="route" :headers="headers" :route="route"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";
// import {mapActions} from "vuex";

export default {
  data()
  {
    return {
      id:null,
      route : null,
      customer : null,
      headers:[
        'مشتری',
        'تیپ خودرو',
        'سال ساخت',
        'کیلومتر فعلی',
        'آخرین مراجعه',
        'امکانات'
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
    this.route = 'CustomerCars/ListAjax';
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  },
  watch: {
    // '$route.path': {
    //   handler(newUrl)
    //   {
    //     if (newUrl.indexOf('CustomerCar/list') >= 0)
    //     {
    //       this.id = this.$route.params.id;
    //       this.route = 'car/ListAjax?customer_id='+this.id+'&t=' + (new Date().getTime())
    //     }
    //   }
    // }
  }
};
</script>

<style scoped>
.top_items
{
  display: flex;
  justify-content: space-between;
}
.h5 {
  font-weight: 900;
  font-size: 15px;
  align-self: center;
  color: #000000b3;
}
</style>